import { useContext } from 'react';
import { AuthContext } from 'auth/SessionProvider';

export const useAuth = () => useContext(AuthContext);
